import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ToastController, LoadingController} from 'ionic-angular';

/*
  Generated class for the StudentProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class StudentProvider {


    url: string = 'http://qbankapiv2.showmywork.in/student/';

    constructor(public http: HttpClient, private toastCtrl: ToastController) {
        console.log('Hello StudentProvider Provider');
    }

    beforeStudent() {
        return this.http.get(this.url + 'beforeStudent').map(res => res);
    }

    getBranch(course_id: any) {
        return this.http.get(this.url + 'getBranch/' + course_id).map(res => res);
    }

    getCollegeData(college_id: any) {
        return this.http.get(this.url + 'getCollegeData/' + college_id).map(res => res);
    }

    addStudent(student_obj: any) {
        return this.http.post(this.url + 'addStudent', student_obj).map(res => res);
    }

    editStudent() {
        return this.http.get(this.url + 'editStudent').map(res => res)
    }
    updateStudentClass(student_obj: any) {
        return this.http.post(this.url + 'updateStudentClass', student_obj).map(res => res);
    }
    presentToast(position: string, msg) {            // toastr Message.
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 2000,
            position: position,
            // cssClass: "success",
        });
        toast.present();
    }

}



// WEBPACK FOOTER //
// ./src/providers/student.ts